// removed by extract-text-webpack-plugin
module.exports = {"helpArticle":"G7cbf5b"};